module.exports = __webpack_public_path__ + "static/media/news1.c7980692.png";